<template>
	<div :class="['game-space', curtainClass]">
		<div :class="['game-space-inner']">
			<div class="game-space-safe-zone">
				<transition :name="transitionName"
					@before-enter="beforeEnterHandler"
					@after-enter="afterEnterHandler"
				>
					<router-view class="game-space-router" name="gameSpace" />
				</transition>
			</div>
		</div>
		<transition name="fade">
			<ModalOverlay class="fast-fade fade-enter-active" v-if="activeModal" />
		</transition>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import ModalOverlay from '@/components/partials/ModalOverlay';

export default {
	name: 'GameSpace',
	components: {
		ModalOverlay,
	},
	props: {
	},
	computed: {
		...mapState({
			activeModal: (state) => state.global.modal.active,
		}),
	},
	data() {
		return {
			curtainClass: "",
			transitionName: "",
			isTransitioning: false,
		};
	},
	methods: {
		beforeEnterHandler() {
			this.isTransitioning = true;
			this.maybeTriggerCurtain();
		},
		afterEnterHandler() {
			this.isTransitioning = false;
			this.resetCurtain();
		},
		maybeTriggerCurtain() {
			if (this.transitionName === "curtain-pan") {
				this.curtainClass = "pan-active";
				this.$nextTick(() => {
					this.curtainClass = "pan-active pan-to";
				});
			}
		},
		resetCurtain() {
			this.curtainClass = "";
		},
	},
	watch: {
		$route(to) {
			this.transitionName = to.meta?.transition ? to.meta.transition : "fade";
		},
	},
};
</script>

<style lang="scss" scoped>
	$props-starting-location: 125vw;

	.game-space {
		height: 100%;
		width: 100%;
		position: absolute;
		left: 0;
		user-select: none;

		background-image:
			url('~@/assets/images/props-1.png'),
			url('~@/assets/images/curtain-background.png');
		background-size:
			47.5vw auto,
			100vw 100%;
		background-repeat:
			no-repeat,
			repeat-x;
		background-position:
			$props-starting-location bottom,
			0vw bottom;

		&.pan-active {
			background-position: $props-starting-location bottom, 0vw bottom;
			transition: background-position $curtain-pan-duration $curtain-pan-timing;
		}

		&.pan-to {
			background-position:
				($props-starting-location - $curtain-pan-distance) bottom,
				-$curtain-pan-distance bottom;
		}

		@include desktop {
			min-height: $min-desktop-height;
		}
	}

	.game-space-inner {
		height: 100%;
		width: 100%;
		align-items: center;
		padding-left: $sidebar-width;
		display: flex;
		flex-direction: row;
		flex-grow: 1;
		justify-content: space-between;
		position: relative;

		@include mobile { padding-left: $sidebar-mobile-width; }
	}

	.game-space-safe-zone {
		position: relative;
		height: 100%;
		width: 100%;
	}

	.game-space-router {
		position: absolute;
		top: 0;
		left: 0;
		height: 100%;
		width: 100%;
	}

</style>



// WEBPACK FOOTER //
// src/components/views/game/GameSpace.vue